import { getQuestionsTypes } from 'core/crud/tests.crud';
import { LEMONADE_TEMPLATES } from 'core/utils/lemonade';
import { successResponse } from 'core/utils/utils';
import { flattenDepth } from 'lodash';
import { useEffect, useState } from 'react';

export default function useAccordionTemplates({ onSelecteType, resetSelection }) {
  const [questionTemplates, setQuestionTemplates] = useState(LEMONADE_TEMPLATES);

  useEffect(() => {
    onGetQuestionTypes();
  }, []);

  useEffect(() => {
    if (resetSelection) {
      onGetQuestionTypes();
    }
  }, [resetSelection]);

  async function onGetQuestionTypes() {
    const typesResponse = await getQuestionsTypes();
    if (successResponse(typesResponse)) {
      let types = typesResponse.data.data;
      setQuestionTemplates(
        LEMONADE_TEMPLATES.map((parent) => {
          return {
            ...parent,
            children: parent.children.map((child) => {
              return { ...child, guid: types.filter((type) => type.name === child.name)[0]?.guid };
            }),
          };
        })
      );
    }
  }

  function onClickTemplate(item) {
    if (item.children) {
      let templatesSelected = parseParentSection(item);
      setQuestionTemplates(templatesSelected);
      onSelecteType(onChangeSelectionHandler(templatesSelected));
    } else {
      let templatesSelected = parseChildrenSection(item);
      setQuestionTemplates(templatesSelected);
      onSelecteType(onChangeSelectionHandler(templatesSelected));
    }
  }

  function parseChildrenSection(item) {
    return questionTemplates.map((parent) => {
      if (parent.children.some((child) => child.guid === item.guid)) {
        return {
          ...parent,
          children: parent.children.map((child) => {
            return { ...child, selected: child.guid === item.guid ? !item.selected : child.selected };
          }),
          selected: parent.children
            .map((child) => {
              return { ...child, selected: child.guid === item.guid ? !item.selected : child.selected };
            })
            .some((child) => child.selected),
        };
      } else return parent;
    });
  }

  function parseParentSection(item) {
    return questionTemplates.map((parent) => {
      if (item.id === parent.id) {
        return {
          ...item,
          children: item.children.map((child) => {
            return { ...child, selected: !item.selected };
          }),
          selected: !item.selected,
        };
      } else return parent;
    });
  }

  function onChangeSelectionHandler(elements) {
    let guids = elements.map((parent) => {
      return parent.children.map((child) => {
        if (child.selected) return child.guid;
      });
    });

    guids = flattenDepth(guids).filter((item) => item !== undefined);
    return guids;
  }

  return { questionTemplates, onClickTemplate };
}
